import { Close, MailOutline, QuizOutlined, WhatsApp } from '@mui/icons-material'
import { Box, Modal } from '@mui/material'
import { useStyles } from './styles'

type THelpModal = {
  openModal: boolean
  setOpenModal: () => void
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  Height: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  overflow: 'hidden',
}

const HelpModal = ({ openModal, setOpenModal }: THelpModal) => {
  const classes = useStyles()

  return (
    <Modal
      open={openModal}
      onClose={setOpenModal}
    >
      <Box sx={style}>
        <Box className={classes.titleAndDescriptionContainer}>
          <Box className={classes.titleAndCloseButton}>
            <span className={classes.title}>Precisa de ajuda?</span>
            <Close
              className={classes.closeBtn}
              onClick={setOpenModal}
            />
          </Box>
          <span className={classes.subTitle}>
            Consulte nossa Central de Ajuda ou entre em contato com o nosso suporte.
          </span>
        </Box>

        <Box className={classes.infosContainer}>
          <Box className={classes.wppContainer}>
            <QuizOutlined />
            <a
              href='https://doc.clickup.com/9007078573/p/h/8cdu75d-5213/b4a8ba1e9bb35c1/8cdu75d-5213'
              target='_blank'
              className={classes.descriptions}
            >
              Central de Ajuda
            </a>
          </Box>
          <Box className={classes.wppContainer}>
            <WhatsApp />
            <a
              href='tel:+55 (32) 99122-1375'
              className={classes.descriptions}
            >
              +55 (32) 91234-1234
            </a>
          </Box>
          <Box className={classes.mailContainer}>
            <MailOutline />
            <a
              href='mailto:suporte@conducco.com'
              className={classes.descriptions}
            >
              suporte@conducco.com
            </a>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default HelpModal
